import React from "react";
import { BankDetails } from "../../interfaces/bank";

 // ── Bank Details Card ─────────────────────────────────────────────────────────
export function BankCard({ details }: { details: BankDetails }) {
  const masked = '*'.repeat(6) + details.accountNumber.slice(-4)
  return (
    <div className="border border-gray-200 rounded-xl p-5 bg-gray-50 max-w-xl space-y-3">
      <p className="text-sm text-gray-700">
        <span className="font-semibold">Bank:</span> {details.bankName}
      </p>
      <p className="text-sm text-gray-700">
        <span className="font-semibold">Account Name:</span> {details.accountName}
      </p>
      <p className="text-sm text-gray-700">
        <span className="font-semibold">Account Number:</span> {masked}
      </p>
    </div>
  )
}